import { render } from "./PlayerShow.vue?vue&type=template&id=79b8b190&scoped=true"
import script from "./PlayerShow.vue?vue&type=script&lang=js"
export * from "./PlayerShow.vue?vue&type=script&lang=js"

import "./PlayerShow.vue?vue&type=style&index=0&id=79b8b190&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b8b190"]])

export default __exports__